import {userIsLoadingAction, userSignedInAction} from "../actions";
import {connect} from "react-redux";
import UserContext from "../../context/UserContext";
import {ProfileModal} from "../../pages/Profile";
import {fetchUserAccountsAction} from "../apicalls/FetchUserAccounts";
import {fetchUserSecurityConfiguration} from "../apicalls/SecurityConfigurationCalls";

const mapStateToProps = (state, ownProps) => {
    const { user } = state;
    return {
        user
    }};

const mapDispatchToProps = dispatch => {
    return {
        reportUserIsLoading: (val) => {
          dispatch(userIsLoadingAction(val))
        },
        reportUserSignedIn: (user) => {
            dispatch(userSignedInAction(user))
        },
        fetchUserAccounts: () => {
            dispatch(fetchUserAccountsAction())
        },
        fetchUserSecurityProfile: () => {
            dispatch(fetchUserSecurityConfiguration())
        }
    }
};

export const UserContextAdapter = connect(mapStateToProps, mapDispatchToProps)(UserContext);
export const ProfileModalAdapter = connect(mapStateToProps)(ProfileModal);